<template>
    <transition
        enter-active-class="transition duration-200"
        enter-from-class="transform -translate-y-5 opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition duration-75"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform -translate-y-5 opacity-0"
        appear
    >
        <slot />
    </transition>
</template>